import { render, staticRenderFns } from "./diapositiva 2_2.vue?vue&type=template&id=3ddfdd30&scoped=true&"
var script = {}
import style0 from "./diapositiva 2_2.vue?vue&type=style&index=0&id=3ddfdd30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddfdd30",
  null
  
)

export default component.exports